angular.
module("dx.webapp.library").
directive("dxQuestionDraggable", function questionDraggableDirective(
	$sanitize
) {
	"use strict";

	return {
		scope: {
			question: "=",
			draggable: "=",
		},
		restrict: "A",
		link: link,
	};

	function link($scope, element) {
		if (!$scope.draggable) {
			return;
		}

		element.draggable({
			revert: true,
			revertDuration: 0,
			cursorAt: {
				left: 150,
				top: 15,
			},
			zIndex: 20,
			helper: function helper() {
				var $el = angular.element("<div />").addClass("library_entry library_draggingHelper question");
				$el.data("question", $scope.question);

				var $title = angular.element("<div />").addClass("title");

				$el.append($title);

				var html = "<p>" + $sanitize($scope.question.title) + "</p>";

				$title.html(html);
				var $clear = angular.element("<div />").addClass("clearer");

				$el.append($clear);

				var about = $sanitize($scope.question.about);

				if (about.length >= 100) {
					about = about.slice(0, 97) + "...";
				}

				var $about = angular.element("<div />").addClass("about");
				$about.html("<p>" + about + "</p>");

				$el.append($about);

				return $el;
			},
		});
	}
});
